import {Response, Model, ID} from '@/_metronic/helpers'

export type Status = {
  date: Date
  status: string
  remark?: string
}

export type PaymentInstruction = {
  keyword?: string,
  shortcode?: string,
  phone?: string
}

export type PaymentError = {
  status?: string
  statusText?: string
  message?: string
}

export type Transaction = {
  psp: {
    trxId?: string
    name: string
  },
  instructions?: PaymentInstruction
  error?: PaymentError
  type?: string
  amount?: number
  currency?: string
  country: string
  trxId: string
  code?: string
  payout?: number
  payoutCurrency?: string
  test: boolean
  msisdn?: string
  alias?:string;
  carrier?:string;
}

export type Order = {
  product: {
    _id: ID
    name: string
  },
  voucher?: {
    _id: ID
    code: string
    amount: number
  },
  discount?: {
    code: string
    prc: number
  }
  gift?: {
    email: string
    message?: string
  }
  error?: Record<string, string>
}

export type Operation = Model & {
  date: Date
  user: {
    _id: ID
    email: string
    username: string
  }
  type: string
  statuses: Status[]
  credit?: number
  debit?: number
  currencyRate: number
  fingerprint?: string
  ip: string
  transaction?: Transaction
  order?: Order
  parent?: Operation
}

export type MissingCreditTrx = Model & {
  date: Date
  credit: number
  amount: number
  currency: string
  payout: number
  country: string
  code: string
  type: string
}

export const types = [
  'carryover',
  'exceptional_credits',
  'order',
  'payment',
  'review',
  'sponsorship',
  'transfer'
]

export type OperationsQueryResponse = Response<Array<Operation>>
